module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('select', [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16dc8373"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Selectize.vue
// module id = 1626
// module chunks = 2